import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';

/**
 * The open workspace's Speaker Format (`branding.speakerFormat`, PLAT-12176),
 * for the screens that show a speaker's Title line: pass it to
 * `formatSpeakerRole` / `speakerTitleLine`, which fall back to the default
 * when it is undefined or unreadable (PLAT-12261).
 */
export function useWorkspaceSpeakerFormat(): unknown {
  return useVideoCreatorStore().organization?.branding?.speakerFormat;
}
